var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Doc", style: { width: _vm.width } }, [
    _c("nav", { staticClass: "Doc_NavBar" }, [
      _c("ul", { staticClass: "Doc_NavBarTools" }, [
        _c("li", { staticClass: "Doc_NavBarToolItem" }, [
          _vm.editable
            ? _c(
                "button",
                {
                  staticClass: "Doc_NavBarIconButton",
                  on: { click: _vm.toggleShowEditor }
                },
                [
                  _c("FontAwesomeIcon", { attrs: { icon: "edit", size: "1x" } })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "Doc_Info" }, [
        _c("li", { staticClass: "Doc_InfoItem" }, [
          _vm._v(
            "\n        LastUpdate: " +
              _vm._s(_vm.dateFormat(_vm.updatedDate)) +
              " " +
              _vm._s(_vm.updatedAuthorName) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "Doc_InfoItem" }, [
          _vm._v(
            "Created: " +
              _vm._s(_vm.dateFormat(_vm.createdDate)) +
              " " +
              _vm._s(_vm.createdAuthorName)
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showEditor,
            expression: "!showEditor"
          }
        ],
        staticClass: "Doc_Inner"
      },
      [
        _c("div", {
          ref: "doc",
          staticClass: "UISP-Md",
          domProps: { innerHTML: _vm._s(_vm.convertedHtml) }
        })
      ]
    ),
    _vm._v(" "),
    _vm.editable
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEditor,
                expression: "showEditor"
              }
            ],
            staticClass: "Doc_Editor"
          },
          [
            _c("DocEditor", {
              staticClass: "Doc_DocEditor",
              attrs: { headlineIndex: _vm.headlineIndexToEdit },
              on: {
                openTreeDialog: _vm.openTreeDialog,
                closeEditor: _vm.closeEditor
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }